// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { GridFluid, GridFluidItem } from '@riseart/grid';
import { CaptionFigure, EmbeddedMedia } from '@riseart/common';
import { EmptyContent } from '@riseart/layout';
import { ArtistComment } from '@riseart/artist';
import { PicturePlaceholder } from 'shared_components/common/artdirection/picture/Picture';
import { artist as ENUM_ARTIST } from 'Enum';
import { extractImageFileFromData } from 'shared_services/riseart/utils/ImageUtils';

type Props = {
  items: Array<Object>,
  wrapperPaddings?: Object,
  isLoading: boolean,
};

/**
 * StudioFeedGrid
 *
 * @param props
 * @returns {Node}
 */
export const StudioFeedGrid = ({ items, wrapperPaddings, isLoading }: Props) => {
  if (!isLoading && (!items || !items.length)) {
    return (
      <EmptyContent>
        <FormattedMessage id="components.artist.noStudioFeed">
          {(text: string) => text}
        </FormattedMessage>
      </EmptyContent>
    );
  }

  return (
    <GridFluid
      columnCount="2"
      wrapperPaddings={wrapperPaddings}
      windowWidth={typeof window !== 'undefined' && window.innerWidth}
    >
      {() =>
        items.map((item) => {
          if (item.mediaType === ENUM_ARTIST.feed.type.TYPE_TEXT) {
            return (
              <GridFluidItem columnCount={2} key={item.id}>
                <ArtistComment size="medium" author={item.title} showAuthorDash>
                  {item.text}
                </ArtistComment>
              </GridFluidItem>
            );
          }
          if (
            [ENUM_ARTIST.feed.type.TYPE_IMAGE, ENUM_ARTIST.feed.type.TYPE_VIDEO].indexOf(
              item.mediaType,
            ) !== -1
          ) {
            return (
              <GridFluidItem columnCount={2} key={item.id}>
                <CaptionFigure caption={item.title} align="left">
                  {item.mediaType === ENUM_ARTIST.feed.type.TYPE_IMAGE ? (
                    <PicturePlaceholder
                      type="artist.feedList"
                      artDirectionKey="artist.feed"
                      image={extractImageFileFromData.artistFeedImage(item.images)}
                      alt={item.title || ''}
                      lazyload
                    />
                  ) : (
                    <EmbeddedMedia platform={item.mediaPlatform} id={item.mediaId} />
                  )}
                </CaptionFigure>
              </GridFluidItem>
            );
          }

          return null;
        })
      }
    </GridFluid>
  );
};
